import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import htmlParser from 'react-html-parser';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {
        width: '100%',
        '& img, & iframe': {
          maxWidth: '100%'
        }
      }
    }
  );
}, {
  name: 'SxProductLongDescription'
});

function ProductLongDescription(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      content = _ref.content,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "content"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), htmlParser(content));
}

ProductLongDescription.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  content: PropTypes.string.isRequired
};
ProductLongDescription.defaultProps = {
  classes: undefined,
  className: undefined
};
export default ProductLongDescription;